import React, { Dispatch, SetStateAction } from "react";
import { ICooperativeDetails } from "../../exports/interfaces";
import Select from "react-select";
import {
  customSelectStyles,
  SelectOption,
} from "../../exports/customSelectStyles";
import { useOption } from "../../context/OptionContext";

const CooperativeInfo = ({
  currentStep,
  cooperativeInfo,
  setCooperativeInfo,
  errors,
}: {
  currentStep: number;
  cooperativeInfo: ICooperativeDetails;
  setCooperativeInfo: Dispatch<SetStateAction<ICooperativeDetails>>;
  errors: any;
}) => {
  const { categories } = useOption();
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;

    setCooperativeInfo((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const natureOfWorkOptions =
    categories
      ?.find((item) => item.name === "Nature of Work")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const workingAreaOptions =
    categories
      ?.find((item) => item.name === "Working Area")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const registeredAtOptions =
    categories
      ?.find((item) => item.name === "Registration Area")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const yesNoOptions = [
    { value: "true", label: "Yes" },
    { value: "false", label: "No" },
  ];

  const handleSelectChange = (
    name: keyof ICooperativeDetails,
    selected: SelectOption | null,
  ) => {
    setCooperativeInfo((prev) => ({
      ...prev,
      [name]: selected?.value,
    }));
  };
  return (
    <>
      <div
        className={`dashboard-card ${currentStep !== 2 ? "mt-2" : ""}`}
        style={currentStep === 2 ? { borderTopLeftRadius: 0 } : {}}
      >
        <div className="row g-3">
          <div className="col-12">
            <div className="row g-3">
              <div className={`col-lg-6 col-md-4`}>
                <label className="form-label">
                  Registration number <span className="primary-color">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter registration number here"
                  name="registrationNumber"
                  value={cooperativeInfo.registrationNumber}
                  onChange={handleChange}
                />
              </div>
              <div className={`col-lg-6 col-md-4`}>
                <label className="form-label">
                  Business Registration Number{" "}
                  <span className="primary-color">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Business registration here"
                  name="businessregistrationNumber"
                  value={cooperativeInfo.businessregistrationNumber}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="dashboard-card mt-3">
              <h5 className="text-uppercase mb-4">COOPERATIVE IDENTITY</h5>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label">
                    Full Cooperative name in Nepali{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Nepali name here"
                    name="nameNepali"
                    value={cooperativeInfo.nameNepali}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Full Cooperative name in English{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter English name here"
                    name="nameEnglish"
                    value={cooperativeInfo.nameEnglish}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Nature of Work <span className="primary-color">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={natureOfWorkOptions}
                    placeholder="Select nature of work"
                    value={
                      natureOfWorkOptions.find(
                        (option) =>
                          option.value === cooperativeInfo.natureOfWork,
                      ) || null
                    }
                    onChange={(selected) =>
                      handleSelectChange("natureOfWork", selected)
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Working area <span className="primary-color">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={workingAreaOptions}
                    placeholder="Select working area"
                    value={
                      workingAreaOptions.find(
                        (option) =>
                          option.value === cooperativeInfo.workingArea,
                      ) || null
                    }
                    onChange={(selected) =>
                      handleSelectChange("workingArea", selected)
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Cooperative PAN Number{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Cooperative Pan no. here"
                    name="panNumber"
                    value={cooperativeInfo.panNumber}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="dashboard-card mt-2">
              <h5 className="text-uppercase mb-4">Contact Information</h5>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label">
                    Administrator’s Name{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Administrator name here"
                    name="contactPerson"
                    value={cooperativeInfo.contactPerson}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Administrator’s Mobile Number{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter mobile number here"
                    name="mobileNumber"
                    value={cooperativeInfo.mobileNumber}
                    onChange={handleChange}
                  />
                  {errors.mobileNumber && (
                    <p className="error-message">{errors.mobileNumber}</p>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Administrator’s Email{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Administrator email here"
                    name="email"
                    value={cooperativeInfo.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <p className="error-message">{errors.email}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="dashboard-card mt-2">
              <h5 className="text-uppercase mb-4">Registration Information</h5>
              <div className="row g-4">
                <div className="col-md-3">
                  <label className="form-label">
                    Cooperative Registered Date (Nepali){" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control custom-date"
                    required
                    name="registeredDate"
                    value={cooperativeInfo.registeredDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Cooperative Registered Date (English){" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control custom-date"
                    required
                    name="registeredEnglishDate"
                    value={cooperativeInfo.registeredEnglishDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Registered At <span className="primary-color">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={registeredAtOptions}
                    placeholder="Select registered at"
                    value={
                      registeredAtOptions.find(
                        (option) =>
                          option.value === cooperativeInfo.registeredAt,
                      ) || null
                    }
                    onChange={(selected) =>
                      handleSelectChange("registeredAt", selected)
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Registered Office Name and Address{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter registered Office Name and Address"
                    name="registeredOfficeAddress"
                    value={cooperativeInfo.registeredOfficeAddress}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="dashboard-card mt-2">
              <h5 className="text-uppercase mb-4">Operational Information</h5>
              <div className="row g-4">
                <div className="col-md-4">
                  <label className="form-label">
                    Male Members <span className="primary-color">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control with-spin"
                    placeholder="0"
                    name="maleMembers"
                    value={cooperativeInfo.maleMembers || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Female Members <span className="primary-color">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control with-spin"
                    placeholder="0"
                    name="femaleMembers"
                    value={cooperativeInfo.femaleMembers || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Others Members <span className="primary-color">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control with-spin"
                    placeholder="0"
                    name="otherMembers"
                    value={cooperativeInfo.otherMembers || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Current Working Staffs{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter number of staff here"
                    name="staffCount"
                    value={cooperativeInfo.staffCount || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Name Of The Software Used{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter software used here"
                    name="softwareUsed"
                    value={cooperativeInfo.softwareUsed || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Is registered in any Federation?{" "}
                    <span className="primary-color">*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={yesNoOptions}
                    value={
                      yesNoOptions.find(
                        (opt) =>
                          opt.value ===
                          String(cooperativeInfo.isRegisteredInFederation),
                      ) || null
                    }
                    onChange={(selected) =>
                      setCooperativeInfo((prev) => ({
                        ...prev,
                        isRegisteredInFederation: selected?.value === "true",
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CooperativeInfo;
